//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {
      isShow: false,
      show: false,
      showMenus: false,
      menus: { menu1: "修改" },
      showList: [],
      contactList: [],
      invoiceList: [],
      addForm: {
        id: "",
        activeId: "",
        supportOption: "",
        exhibitionType: "",
        showCount: 0,
        sateCount: 0,
        remarks: "",
        userName: "",
        cellPhone: "",
        email: "",
        invoiceType: "",
        invoiceTitle: "",
        taxNo: "",
        telAddress: "",
        bankCount: "",
        mailAddress: "",
        dynamicCount: 0,
        businessCount: 0,
        sponsorCount: 0,
        drink: 0,
        teaBreak: 0,
        guide: 0,
      },
      inShowList: [
        {
          // title: '参展说明',
          desc:
            "展位规格3m*3m，特装展位需自付特装费，标准展位免费提供一桌两凳。",
          meta: {
            source: "展位5万元/个",
            date: "",
            other: "卫星会10万元/场/30min"
          }
        }
      ],
      donateList: [
        {
          // title: '捐赠说明',
          desc:
            "捐赠不提供任何形式的展览或卫星会，捐赠前务必明确捐赠类型，可具体咨询学会负责人。"
        }
      ],
    };
  },
  async mounted() {
    this.addForm.id = this.$route.params.id;
    this.addForm.cellPhone = this.$route.params.cellPhone;
    await this.queryInfo(this.$route.params.id);
  },
  methods: {
    /**
     * 返回首页
     *
     */
    goback() {
      this.$router.push({
        name: "loginSelect",
        params: { id: this.addForm.activeId }
      });
    },
    /**
     * 获取提交信息
     *
     */
    async queryInfo(id) {
      const getModel = this.$apis.exhibition.getModel;
      try {
        const { data } = (await this.$axios.get(`${getModel}/${id}`)) || {};
        this.addForm = data;
        this.modelInit();
      } catch (err) {
        this.showMsg(err.data.msg);
      }
    },
    /**
     * 修改跳转
     *
     */
    editClick() {
      console.log("修改");
      this.$router.push({
        name: "edit",
        params: this.addForm
      });
    },
    /**
     * 数据初始化
     *
     */
    modelInit() {
      this.showList.push({
        label: "参与性质",
        value: this.addForm.supportOption
      });
      if(this.addForm.supportOption === '参展'){
        this.isShow = true;
        if (this.addForm.exhibitionType === "S") {
          this.showList.push({ label: "展位类别", value: "标准展位" });
        } else {
          this.showList.push({ label: "展位类别", value: "特装展位" });
        }
        this.showList.push({
          label: "展位数",
          value: this.addForm.showCount
        });
        this.showList.push({
          label: "卫星会",
          value: this.addForm.sateCount
        });
        this.showList.push({
          label: "动态展示页",
          value: this.addForm.dynamicCount
        });
        this.showList.push({
          label: "企业展示页",
          value: this.addForm.businessCount
        });
        this.showList.push({
          label: "网络赞助商",
          value: this.addForm.sponsorCount
        });
        this.showList.push({
          label: "大会饮水",
          value: this.addForm.drink
        });
        this.showList.push({
          label: "会议茶歇",
          value: this.addForm.teaBreak
        });
        this.showList.push({
          label: "会议指引牌",
          value: this.addForm.guide
        });
        this.showList.push({
          label: "其他需求",
          value: this.addForm.remarks
        });
      }

      this.contactList.push({
        label: "姓名",
        value: this.addForm.userName
      });
      this.contactList.push({
        label: "联系手机",
        value: this.addForm.cellPhone
      });
      this.contactList.push({ label: "邮箱", value: this.addForm.email });

      this.invoiceList.push({
        label: "发票类别",
        value: this.addForm.invoiceType
      });
      this.invoiceList.push({
        label: "抬头",
        value: this.addForm.invoiceTitle
      });
      this.invoiceList.push({ label: "税号", value: this.addForm.taxNo });
      if(this.addForm.supportOption === '参展'){
        this.invoiceList.push({
          label: "地址电话",
          value: this.addForm.telAddress
        });
        this.invoiceList.push({
          label: "银行账号",
          value: this.addForm.bankCount
        });
      }
      this.invoiceList.push({
        label: "邮寄地址",
        value: this.addForm.mailAddress
      });
    },
    /**
     * 显示提示信息
     *
     */
    showMsg(msg) {
      this.errorMsg = msg;
      this.showPositionValue = true;
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/info.vue